import React from "react"
import { connect } from "react-redux"
import { Helmet } from "react-helmet"
import { createStructuredSelector } from "reselect"
import { compose } from "redux"

import injectSaga from "utils/injectSaga"
import injectReducer from "utils/injectReducer"
import SummaryScreen from "components/SummaryScreenV2"
import Loader from "components/Loader"
import { pick, get } from "lodash"
import { Modal, Button, Progress, Checkbox, Popover } from "antd"
import check from "../../images/check.svg"

import {
  makeSelectSummary,
  makeSelectIsLoadingSummary,
  makeSelectPercentage,
} from "./selectors"
import {
  getRecipientsSummaryWatcher,
  uploadTemplateRecipientsWatcher,
  saveExcelRecipientsWatcher,
} from "./actions"
import reducer from "./reducer"
import saga from "./saga"

import "./index.less"

export function MeasurementRecipientsSummary(props) {
  const [modalProgress, setModalProgress] = React.useState(false)

  React.useEffect(() => {
    props.getRecipientsSummaryWatcher()
    localStorage.setItem("currentMeasure", props.match.params.id)
  }, [])

  return (
    <React.Fragment>
      <Helmet>
        <title>Importar Destinatarios Summary</title>
      </Helmet>
      {props.isLoadingSummary ? (
        <Loader />
      ) : (
        <div className="RecipientSummary-screen">
          <SummaryScreen
            backTitle="Seleccionar destinatarios"
            backModalTitle="¿Estás seguro de que deseas salir de la importación?"
            content={["dni", "nombre", "apellido", "error", "row"]}
            gridHeader="140px 160px 160px 1.5fr 40px"
            gridContent="140px 160px 160px 1.5fr 40px"
            header={["DNI", "Nombre", "Apellidos", "Error", "Fila"]}
            hasUpdates={false}
            history={props.history}
            maxWidthTable="90%"
            modalFinalize={
              <React.Fragment>
                <span style={{ fontWeight: 600, fontSize: 14 }}>
                  ¿Estás seguro de que deseas finalizar la importación de
                  destinatarios?
                </span>
              </React.Fragment>
            }
            onFinalize={(params) => {
              setModalProgress(true)
              props.saveExcelRecipientsWatcher(params)
            }}
            textResume={{
              text: "destinatario",
              success: (
                <React.Fragment>
                  <span>{`${get(props.summary, "count_import", 0)} `}</span>
                  {`${plural(
                    "destinatario",
                    get(props.summary, "count_import", 0),
                    "s"
                  )} ${plural(
                    "importado",
                    get(props.summary, "count_import", 0),
                    "s"
                  )}`}
                </React.Fragment>
              ),
              failed: (
                <React.Fragment>
                  <span>{`${get(props.summary, "count_error", 0)} `}</span>
                  {`${plural(
                    "destinatario",
                    get(props.summary, "count_error", 0),
                    "s"
                  )} sin importar`}
                </React.Fragment>
              ),
            }}
            title="destinatarios"
            uploadTemplate={props.uploadTemplateRecipientsWatcher}
            urlBack={`/models/measure-create/${props.match.params.id}?step=3`}
            {...pick(props.summary, [
              "count_import",
              "count_error",
              "list_errors",
            ])}
          />
        </div>
      )}

      <Modal
        visible={modalProgress}
        okText="Aceptar"
        closable={false}
        footer={
          props.percentage !== 100
            ? null
            : [
                <Button
                  key="submit"
                  type="primary"
                  onClick={() => {
                    setModalProgress(false)
                    props.history.push(
                      `/models/measure-create/${props.match.params.id}?step=3`
                    )
                  }}>
                  Aceptar
                </Button>,
              ]
        }
        width={520}>
        {props.percentage !== 100 ? (
          <div className="modalSuccess">
            <Progress
              style={{ margin: "0 auto" }}
              width={80}
              type="circle"
              percent={props.percentage}
            />
            <span
              style={{
                justifySelf: "center",
                alignSelf: "center",
                marginTop: "1em",
                fontSize: "14px",
                color: "#555151",
              }}>
              La importación puede tardar unos minutos...
            </span>
          </div>
        ) : (
          <div className="modalSuccess" style={{ textAlign: "center" }}>
            <img src={check} />
            <span style={{ marginTop: 14, fontWeight: 600, color: "#555151" }}>
              La importación ha sido completada con éxito.
            </span>
          </div>
        )}
      </Modal>
    </React.Fragment>
  )
}

const mapStateToProps = createStructuredSelector({
  summary: makeSelectSummary(),
  isLoadingSummary: makeSelectIsLoadingSummary(),
  percentage: makeSelectPercentage(),
})

function mapDispatchToProps(dispatch) {
  return {
    getRecipientsSummaryWatcher: () => dispatch(getRecipientsSummaryWatcher()),
    uploadTemplateRecipientsWatcher: (params) =>
      dispatch(uploadTemplateRecipientsWatcher(params)),
    saveExcelRecipientsWatcher: (params) =>
      dispatch(saveExcelRecipientsWatcher(params)),
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)

const withReducer = injectReducer({ key: "recipientsSummary", reducer })
const withSaga = injectSaga({ key: "recipientsSummary", saga })

export default compose(
  withReducer,
  withSaga,
  withConnect
)(MeasurementRecipientsSummary)
